import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=9d67f64e"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d67f64e')) {
      api.createRecord('9d67f64e', component.options)
    } else {
      api.reload('9d67f64e', component.options)
    }
    module.hot.accept("./TabPane.vue?vue&type=template&id=9d67f64e", function () {
      api.rerender('9d67f64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaTabs/TabPane.vue"
export default component.exports